function distance(num) {
  if (typeof (num) !== 'number') return ''
  return Math.rounded(num * 10) / 10 + ' mi.'
}

export default distance